<template>
  <div class="home">
    <Banner id="thetop" />
    <Introduce />
    <div class="module product" id="product">
      <div class="container">
        <Product />
      </div>
    </div>
    <div class="module guide" id="guide">
      <div class="container">
        <h3 class="module-title" style="text-align:center">学习指引</h3>
        <div class="guideContent" :style="guidebg">
          <el-carousel indicator-position="none">
            <el-carousel-item v-for="(item,index) in QRcode" :key="index">
              <img :src="item.img" alt />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="module videos">
      <div class="container">
        <Videos />
      </div>
    </div>
    <!-- <div class :style="moreBg">
      <div  class="container" style="text-align:center;">
          <h2  style="padding:75px 0 50px 0;color:#fff;">更多平台、标准产品教学视频</h2>
          <el-button  style="margin:0 auto"  @click="goVideoList">查看更多</el-button>

      </div>
    </div> -->
  </div>
</template>

<script>
// @ is an alias to /src
import Product from "@/components/Product.vue";
import Banner from "@/components/Banner.vue";
import Introduce from "@/components/Introduce.vue";
import Videos from "@/components/Videos.vue";
export default {
  name: "Home",
  data() {
    return {
      bannerbg: `background:url(${require("../assets/images/getech/banner1.jpg")}) no-repeat scroll top center/100% auto;`,
      guidebg: `background:url(${require("../assets/images/getech/guide.jpg")}) no-repeat scroll top center/100% auto;`,
      QRcode: [
        {
          img: require("../assets/images/getech/qq.png"),
        },
        {
          img: require("../assets/images/getech/weixun.png"),
        },
      ],
      moreBg: `background:url(${require("../assets/images/more_bg.png")}) no-repeat scroll top center/auto 100%;height:280px;`,
    };
  },
  methods: {
    goIndustry(link) {
      this.$router.push({
        path: link,
      });
    },
    goVideoList() {
      this.$router.push({
        path: "/videoList",
      });
    },
  },
  components: {
    Product,
    Banner,
    Introduce,
    Videos,
  },
};
</script>
<style lang="scss" scoped>
.module {
  &.case {
    .module-title {
      text-align: center;
    }
  }
  &.system {
    .module-title {
      text-align: center;
    }
  }
}
</style>